import heic2any from 'heic2any';
import { RECEIPT_ACCEPT, RECEIPT_MAX_MB } from './constants';

const ALLOWED_RECEIPT_TYPES = new Set([
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
]);

const HEIC_TYPES = new Set(['image/heic', 'image/heif']);

const isHeicFile = (file) => {
    const type = (file.type || '').toLowerCase();
    if (HEIC_TYPES.has(type)) {
        return true;
    }

    const name = (file.name || '').toLowerCase();
    return name.endsWith('.heic') || name.endsWith('.heif');
};

const convertHeicToJpeg = async (file) => {
    const result = await heic2any({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.92,
    });

    const blob = Array.isArray(result) ? result[0] : result;
    const baseName = (file.name || 'receipt').replace(/\.(heic|heif)$/i, '');
    return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
};

export const prepareReceiptForUpload = async (file) => {
    if (!file) {
        throw new Error('No file selected');
    }

    let prepared = file;

    if (isHeicFile(file)) {
        prepared = await convertHeicToJpeg(file);
    }

    const maxBytes = RECEIPT_MAX_MB * 1024 * 1024;
    if (prepared.size > maxBytes) {
        throw new Error(`File must be smaller than ${RECEIPT_MAX_MB}MB`);
    }

    const type = prepared.type || 'application/octet-stream';
    if (!ALLOWED_RECEIPT_TYPES.has(type)) {
        throw new Error('Only PDF, JPEG, PNG, or WebP files are supported');
    }

    return {
        file: prepared,
        type,
        size: prepared.size,
        originalFilename: file.name || prepared.name || 'receipt',
    };
};

export { ALLOWED_RECEIPT_TYPES, RECEIPT_ACCEPT };
